import { createTheme } from '@mantine/core';

const aviaryTheme = createTheme({
  primaryColor: 'aviary',
  colors: {
    aviary: [
      '#f0f9ff',
      '#e0f2fe',
      '#bae6fd',
      '#7dd3fc',
      '#38bdf8',
      '#0ea5e9',
      '#0284c7',
      '#0369a1',
      '#075985',
      '#0c4a6e',
    ],
    // v2 sage palette — #3C8C7C at index 6 (Mantine's default filled shade)
    sage: [
      '#f4faf8',
      '#e4f0ec',
      '#c7e0d8',
      '#a3ccc0',
      '#77b3a3',
      '#4f9c8a',
      '#3c8c7c',
      '#2a6659',
      '#1e4a41',
      '#12332c',
    ],
  },
  fontFamily: 'Inter, system-ui, sans-serif',
  defaultRadius: 'md',
});

export default aviaryTheme;
